/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExtensionProfitPreviewItemDTOFromJSON, ExtensionProfitPreviewItemDTOToJSON, } from './ExtensionProfitPreviewItemDTO';
import { OrderProfitabilityDTOFromJSON, OrderProfitabilityDTOToJSON, } from './OrderProfitabilityDTO';
/**
 * @export
 */
export const ExtensionProfitPreviewDTOOrderStatusEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * @export
 */
export const ExtensionProfitPreviewDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * Check if a given object implements the ExtensionProfitPreviewDTO interface.
 */
export function instanceOfExtensionProfitPreviewDTO(value) {
    return true;
}
export function ExtensionProfitPreviewDTOFromJSON(json) {
    return ExtensionProfitPreviewDTOFromJSONTyped(json, false);
}
export function ExtensionProfitPreviewDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'shipByDate': json['shipByDate'] == null ? undefined : (new Date(json['shipByDate'])),
        'deliverByDate': json['deliverByDate'] == null ? undefined : (new Date(json['deliverByDate'])),
        'shippinglotOrderId': json['shippinglotOrderId'] == null ? undefined : json['shippinglotOrderId'],
        'items': json['items'] == null ? undefined : (json['items'].map(ExtensionProfitPreviewItemDTOFromJSON)),
        'profitability': json['profitability'] == null ? undefined : OrderProfitabilityDTOFromJSON(json['profitability']),
        'productCostFromRequest': json['productCostFromRequest'] == null ? undefined : json['productCostFromRequest'],
    };
}
export function ExtensionProfitPreviewDTOToJSON(json) {
    return ExtensionProfitPreviewDTOToJSONTyped(json, false);
}
export function ExtensionProfitPreviewDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderId': value['amazonOrderId'],
        'marketplace': value['marketplace'],
        'orderStatus': value['orderStatus'],
        'packageStatus': value['packageStatus'],
        'shipByDate': value['shipByDate'] == null ? undefined : ((value['shipByDate']).toISOString()),
        'deliverByDate': value['deliverByDate'] == null ? undefined : ((value['deliverByDate']).toISOString()),
        'shippinglotOrderId': value['shippinglotOrderId'],
        'items': value['items'] == null ? undefined : (value['items'].map(ExtensionProfitPreviewItemDTOToJSON)),
        'profitability': OrderProfitabilityDTOToJSON(value['profitability']),
        'productCostFromRequest': value['productCostFromRequest'],
    };
}
